<script setup>
</script>

<template>
  <v-container fluid style="min-height: 100vh;">
    <v-card variant="tonal">
      <v-card-title>
        Welcome to the Associated Claimslink app!
      </v-card-title>
      <v-card-text>
        Choose a dashboard on the left to get started.
      </v-card-text>
    </v-card>
  </v-container>

</template>